/*!
=========================================================
* リスト型ViewのBase
=========================================================
*/
import React,{createRef} from "react";

import {
    Card, CardHeader, CardBody,CardTitle,
    Row, Col,
    FormGroup
} from "reactstrap";

import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import CustomTableTree from '../ViewParts/OriginalTableTree';
import TitleWithBadge from '../FormParts/TitleWithBadge';

export default class ListBaseTreeUnlimit extends React.Component {
    default_column = [];
    default_sub_column = [];
    default_thr_column = [];
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            add_url: undefined,
            search_url: '/',
            data: [],
            column: this.default_column,
            sub_column: this.default_sub_column,
            thr_column: this.default_thr_column,
            tmp_set: false,
            tmp_cnt: 0,
            with_all_check: false,
            default_search: true,
            header_md:"6",
            checkbox_field_in_table:false,
            // #1168 1000件対応
            data_count : 0,
            paging : {
                "index":0,
                "limit":50
            },
            show_detail_search_field : true,
            defaultSortedColumn:[],
        };
        this.searchWithPageIndex = this.searchWithPageIndex.bind(this)
        this.search = this.search.bind(this)

        /* 2021/07/19 1000件対応 */
        this.contentRef = createRef();
        this.pageChangeHandle = this.pageChangeHandle.bind(this);
        this.search_count = this.search_count.bind(this);
        this.changeForLimit = this.changeForLimit.bind(this);
        this.search_for_pager = this.search_for_pager.bind(this)
    }
    
    searchWithPageIndex(pageIndex = 0){
        this.setState({
            pageIndex,
            page:{"index":pageIndex}
        })
        this.search()
    }
    pageChangeHandle( customTable ){
        window.scrollTo(0,customTable.currentRef.current.offsetTop);
        return ;
    }

    dataMap(data) {
        return null;
    }

    validate() {
        return false;
    }

    search_params() {
        return {};
    }

    // 検索
    search() {
        /* ここは開発者が記述 */
        if (!this.validate()) {
            // do nothing
            return;
        }
        this.search_count();

        var searchParam = this.search_params();
        searchParam["pager_index"] = 0;
        searchParam["pager_limit"] = this.state.paging["limit"];

        Request.get(this.state.search_url, searchParam, res => {
            this.props.refreshTaskCount()
            this.setState({
                paging: {
                    "index": parseInt(searchParam["pager_index"]),
                    "limit": parseInt(searchParam["pager_limit"])
                }, 
                data: this.dataMap(res.data)
            });
        })
        
    }
    /* #1189 - 2021/7/19 データ件数の取得 */
    search_count() {
        var search_param = this.search_params();
        Request.get(this.state.search_url, search_param, res => {
            this.setState({data_count: res.data});
        })
    }

    search_for_pager (pager) {
        var search_param = this.search_params();
        search_param["pager_limit"] = pager["limit"];
        search_param["pager_index"] = pager["index"];
        Request.get(this.state.search_url, search_param, res => {
            this.reloadBaseData(res.data,pager);
        })
    }

    search_field_cols() {
        return (
            <>
            </>
        );
    }
    add_field_cols(){
        return (
            <>
            </>
        );
    }
    detail_search_field_btn(){
        return (<></>);
    }
    detail_search_field_cols(){
        return (<></>);
    }
    add_button_field(){
        return (<></>);
    }
    checkbox_field_cols(){
        return (<></>);
    }
    action_cols() {
        return (
            <>
            </>
        );
    }
    dialog_defines() {
        return (
            <>
            </>
        );
    }
    message_field_cols(){
        return (
            <>
            </>
        )
    }
    changeForLimit (limit) {
        this.search_for_pager({"limit":limit, "index":0});
    }

    paging ( table, pager ) {
        console.log("listbase : paging : ", pager)
        var search_param = this.search_params();
        search_param["pager_limit"] = pager["limit"];
        search_param["pager_index"] = pager["index"];

        Request.get(this.state.search_url, search_param, res => {
            this.reloadBaseData(res.data,pager);
        })
        window.scrollTo(0,table.currentRef.current.offsetTop);
    }

    reloadBaseData (baseData,　pager=this.state.paging) {
        let conv_data = this.dataMap(baseData);
        this.setState({
            data: conv_data,
            paging:pager,
        });
    }

    render() {
        let search_field_cols = this.search_field_cols();
        let add_field_cols = this.add_field_cols();
        let detail_search_field_btn = this.detail_search_field_btn();
        let detail_search_field_cols = this.detail_search_field_cols();
        let add_button_field = this.add_button_field();
        let checkbox_field_cols = this.checkbox_field_cols();
        let action_cols = this.action_cols();
        let dialog_defines = this.dialog_defines();
        let message_field_cols = this.message_field_cols();
        const {
            checkbox_field_in_table
        } = this.state
        let data_count = this.state.data_count ? parseInt(this.state.data_count) : 0;

        return (
            <>
                <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md="12" className="HEADER">
                                            <Card className="CardBottomNone">
                                                <CardHeader>
                                                    <Row>
                                                        <Col md={this.state.header_md?this.state.header_md:"6"}>
                                                            {/* <CardTitle tag="h3" className="float-left">
                                                                {this.state.title}
                                                            </CardTitle> */}
                                                            <TitleWithBadge label={this.state.title} badge={this.state.badge} count={this.props.new_arrivals_count[this.props.badge_key]} onclick={() => { this.setState({ tmp_set: !this.state.tmp_set }); }} />
                                                        </Col>
                                                        {this.state.add_url &&
                                                            <Col md="6">
                                                                <ButtonWithTooltip
                                                                    onclick={() => { this.props.history.push(this.state.add_url) }}
                                                                    class="float-right btn-search btn-facebook"
                                                                    id="tmp"
                                                                    icon="fas fa-plus"
                                                                    label="追加"
                                                                    message="データを追加"
                                                                />
                                                            </Col>
                                                        }
                                                        {add_field_cols}
                                                    </Row>
                                                    <Row>
                                                        <Col md="12" className="margin-auto">
                                                            <Card>
                                                                <CardBody className={"search-box " + (this.state.tmp_set ? 'on' : 'off')}>
                                                                　 {message_field_cols}
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        {search_field_cols}
                                                        {/*detail_search_field_btn*/}
                                                    </Row>
                                                    <Row>
                                                        <Col md="3">
                                                            <FormGroup>
                                                                <ButtonWithTooltip
                                                                    onclick={() => this.searchWithPageIndex(0)}
                                                                    class="btn-search"
                                                                    id="tmp"
                                                                    icon="fas fa-search"
                                                                    label="検索"
                                                                    message="検索を開始します。"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="textRight">
                                                    {action_cols}
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    {/*detail_search_field_cols*/}
                                    <CustomTableTree
                                        count={data_count}
                                        page={0}
                                        perPage={50}
                                        pageIndex={this.state.paging["index"]}
                                        handlePageUpdate={(pageIndex)=>this.setState({pageIndex})}
                                        checkbox_field_cols={checkbox_field_in_table?<Row>{checkbox_field_cols}</Row>:<></>}
                                        column={this.default_column}
                                        sub_column={this.default_sub_column} 
                                        thr_column={this.default_thr_column} 
                                        data={this.state.data} 
                                        with_all_check={this.state.with_all_check}
                                        detail_search_field={detail_search_field_cols}
                                        defaultSortedColumn={(this.state.defaultSortedColumn&&this.state.defaultSortedColumn.length>0)?this.state.defaultSortedColumn:undefined}
                                        show_detail_search_field={this.state.show_detail_search_field}
                                        add_button_field={add_button_field}
                                        page_id={this.props.page_id}
                                        limitChangeFunc={(limit)=>this.changeForLimit(limit)}
                                        pageChangeFunc={( customTable,pager) =>{
                                            this.paging( customTable, pager );
                                                if (this.state.auto_scroll == true) {
                                                    this.pageChangeHandle(customTable); 
                                                }
                                            }
                                        }
                                        clickRowCallback={this.clickRowCallback}
                                    />
                                    <Row>
                                    {checkbox_field_in_table?"":checkbox_field_cols}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                {dialog_defines}
            </>
        );
    }
}
